// Base URL of the TDC cube server.
export const TDC_API_BASE =
  process.env.TDC_API_URL ||
  process.env.CVNA_APIK_BASE_URL + '/newcar/testdrivecentercube';
